export const actions = {
  set: 'SET::CLONEPROJECT'
}

export const setProjectToClone = project => ({ type: actions.set, projectToClone: project })
export const getProjectToClone = state => state.projectToClone

export default actions